import React, { Component } from 'react';
import _ from 'lodash'
import './App.css';
import LogoLittleShooting from './components/common/Logo-LittleShooting'
import ScrollToTopRoute from "./components/ScrollToTopRoute"
import Home from "./components/Home"
import Contact from "./components/Contact"
import Help from "./components/Help"
import Login from "./components/Login"
import MyAccount from "./components/MyAccount"
import Card, {CheckCard} from "./components/Card"
import { getShoopingCartNumber, getShoopingCart, removeShoppingCart, addShoppingCart } from './functions/shopping-cart'
import { /*isLoginCheck, */listOffers } from './actions/actions'
import Purchase from './components/Purchase'
import { BrowserRouter as Router, Link, withRouter } from 'react-router-dom'
import utils from './utils'
import moment from 'moment'
import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import 'moment/locale/fr';
import MomentLocaleUtils, {
  formatDate,
  parseDate,
} from 'react-day-picker/moment'
import 'react-day-picker/lib/style.css'

class App extends Component {
	constructor(props) {
		super(props)
		this.state = {
			offers: [],
			isOfferTooltipVisible: false,
			isShoppingCartTooltipVisible: false,
			isMobileDevice: this.isMobileDevice(),
		}
	}

	isMobileDevice() {
		//console.log("isIpad ? = " + navigator.userAgent.indexOf('iPad'))
		return ((typeof window.orientation !== "undefined") && (navigator.userAgent.indexOf('iPad') === -1)) || (navigator.userAgent.indexOf('IEMobile') !== -1);
	}
	handleOfferTooltip = (event) => {
		if (this.state.isOfferTooltipVisible) {
			//console.log("this.state.isOfferTooltipVisible = ", this.state.isOfferTooltipVisible)
			this.setState({isOfferTooltipVisible: false})
		} else {
			this.setState({isOfferTooltipVisible: true})
		}
	}
	handleShoppingCartCounterAnimation = (event) => {
		const counter = document.getElementById('shopping-cart-counter')
		counter.classList.add('bounce-in-animation')
		setTimeout(() => {counter.classList.remove('bounce-in-animation')}, 500); 
	}
	handleShoppingCartTooltip = (event) => {
		event.stopPropagation()

		clearTimeout(this.shoppingCartTooltipTimeout)

		if (event.currentTarget.id === "shopping-cart-btn" && event.type === "mouseenter" && !this.state.isShoppingCartTooltipVisible) {
			// Au survol du btn panier on affiche la tooltip AVEC un délai
			this.shoppingCartTooltipTimeout = setTimeout(() => {this.setState({isShoppingCartTooltipVisible: true})}, 800)
		} else if (event.currentTarget.id === "shopping-cart-btn" && event.type === "mouseleave") {
			// En quittant le btn panier
			if (this.state.isShoppingCartTooltipVisible) { // si la tooltip est visible on la laisse visible
				this.setState({isShoppingCartTooltipVisible: true})
			} else { // si la tooltip est cachée on la laisse cachée
				this.setState({isShoppingCartTooltipVisible: false})
			}
		} else if (event.type === "click") {
			// Au click sur le btn panier OU sur l'overlay 
			if (this.state.isShoppingCartTooltipVisible) { // si la tooltip est visible on la cache SANS délai
				this.setState({isShoppingCartTooltipVisible: false})
			} else { // si la tooltip est cachée on l'affiche SANS délai
				this.setState({isShoppingCartTooltipVisible: true})
			}
		}
	} 
	handleOverlay = (event) => {
		if(this.state.isShoppingCartTooltipVisible)
			this.handleShoppingCartTooltip(event)
		if(this.state.isOfferTooltipVisible)
			this.handleOfferTooltip(event)
	}
	componentWillMount = () => {
		listOffers().then(offers => this.setState({ offers }))
		// console.log("isMobileDevice = ", this.isMobileDevice())
		// this.setState({isMobileDevice: this.isMobileDevice()})
	}
	componentDidMount = () => {
	}
	componentWillUnmount = () => {
		window.removeEventListener('scroll', this.handleScroll);
	}

	render() {
		return (
			<div className={"App" + (this.state.isShoppingCartTooltipVisible && this.state.isMobileDevice ? " pos-f of-hidden w100" : "")}>
				<Router>
					<div className="flex-container--column flex-nowrap vh100">
						<HeaderWithRouter
							isShoppingCartTooltipVisible={this.state.isShoppingCartTooltipVisible}
							isMobileDevice={this.state.isMobileDevice}
							handleShoppingCartTooltip={this.handleShoppingCartTooltip}
							handleShoppingCartCounterAnimation={this.handleShoppingCartCounterAnimation}
							offers={this.state.offers}
						/>
						<div id="overlay" className={"pos-f w100 h100 zi2 bgc--secondary o80" + (this.state.isShoppingCartTooltipVisible || this.state.isOfferTooltipVisible ? "" : " is-hidden")} onClick={this.handleOverlay}></div>
						<ScrollToTopRoute exact path="/" render={() => <Home offers={this.state.offers} handleShoppingCartCounterAnimation={this.handleShoppingCartCounterAnimation} isOfferTooltipVisible={this.state.isOfferTooltipVisible} handleOfferTooltip={this.handleOfferTooltip} />} />
						<ScrollToTopRoute path="/login" component={Login} />
						<ScrollToTopRoute exact path="/help" render={() => <Help section='faq'/>} />
						<ScrollToTopRoute path="/help/:section" render={props => <Help section={props.match.params.section}/>} />
						<ScrollToTopRoute path="/contact" render={() => <Contact/>} />
						<ScrollToTopRoute path="/card" component={Card} />
						<ScrollToTopRoute path="/checkCard" component={CheckCard} />
						<ScrollToTopRoute path="/purchase" render={props => <Purchase {...props} offers={this.state.offers} />} />
						<ScrollToTopRoute path="/myaccount/:view" render={props => <MyAccount {...props} offers={this.state.offers} />} />
						<FooterWithRouter
							isOfferTooltipVisible={this.state.isOfferTooltipVisible}
						/>
					</div>
				</Router>
			</div>
		)
	}
}

class Header extends Component {
	constructor(props) {
		super(props)
		this.state = {
			scrolling: false
		}
	}
	componentDidMount = () => {
		window.addEventListener('scroll', this.handleScroll);
	}
	
	componentWillUnmount = () => {
		window.removeEventListener('scroll', this.handleScroll);
	}

	handleScroll = (event) => {
		let scrollY = window.scrollY
		
		if (scrollY < 200 && this.state.scrolling === true) {
			this.setState({scrolling: false});
		} else if (scrollY >= 200 && this.state.scrolling !== true) {
			this.setState({scrolling: true});
		}
	}

	render() {
		let path = this.props.history.location.pathname
		let showLogo = path === '/' ? this.state.scrolling : true
		let headerClass = "pos-f w100 zi5 bgc--inverse"
		headerClass += this.state.scrolling ? " box-shadow" : ""
		headerClass += path !== "/purchase" && path !== "/login" ? "" : " is-hidden"

		return (
			<header id="main-header" role="banner" className={headerClass}> 
				<div className="pos-r mw1140p h90p d-flex mauto ptm pbm tiny-plm tiny-prm small-pll small-prl medium-pll medium-prl large-pll large-prl"> 
					<div id="phonenumber" className={"tiny-w50 small-w40 medium-w50 large-w33 extra-large-w33 mtauto mbauto tiny-pts" + (path !== "/" ? " tiny-hidden small-hidden medium-hidden" : this.state.scrolling ? " tiny-hidden small-hidden medium-hidden" : "")}>
						{/*<div className="w50p pas mrm">Burger</div>*/}
						<div className="d-flex flex-nowrap flex-align-baseline">
							<div className="lnr lnr-phone-handset u-big tiny-ma0 mrs"></div>
							<div>
								<p className="ma0 u-secondary-bold tiny-pls">01 76 35 08 66</p>
								<small className="d-inbl tiny-w90 tiny-hidden small-hidden">du lundi au vendredi de 10h à 18h</small>
							</div>
						</div>
					</div>
					<div className={"tiny-w50 small-w40 medium-w50 large-w33 extra-large-w33 large-txtcenter extra-large-txtcenter" + (!showLogo ? " tiny-hidden small-hidden medium-hidden" : "")}>
						{showLogo ? <LogoLittleShooting className="logo-littleshooting tiny-w70 small-w70 medium-w40 w50 h40p"/> : false}
					</div>
					<div className="medium-w50 large-w33 extra-large-w33 d-flex flex-align-baseline flex-end mtauto mbauto tiny-w50 small-w60">
						<Link to="/myaccount/orders" className="d-flex flex-align-baseline tiny-mrm mrl">
							<span className="lnr lnr-user u-big mts mrs"></span>
							<span className="u-small tiny-hidden">Compte</span>
						</Link>
						<ShoppingCartWithRouter
							isVisible={this.props.isShoppingCartTooltipVisible}
							isMobileDevice={this.props.isMobileDevice}
							handleShoppingCartTooltip={this.props.handleShoppingCartTooltip}
							handleShoppingCartCounterAnimation={this.props.handleShoppingCartCounterAnimation}
							offers={this.props.offers}
						/>
					</div>
				</div>
			</header>
		)
	}
}
const HeaderWithRouter = withRouter(Header)


class Footer extends Component {
	render() {
		let path = this.props.history.location.pathname
		let isFooterVisible = path !== "/purchase" && path !== "/login"
		
		return (
			<footer id="main-footer" role="banner" className={"bgc--secondary color--inverse ptl pbxl flex-item-nofluid zi3" + (this.props.isOfferTooltipVisible || !isFooterVisible ? " is-hidden" : "")}>
				<nav id="navigation" className="mw1140p grid-3 has-gutter-xl mauto ptm pbs pll prl">
					<div className="ptl">
						<p className="u-secondary-bold u-big color--inverse">Un peu de nous</p>
						<ul className="unstyled">
							<li className="pts"><a href="https://www.grand-shooting.com/"><span className="u-small color--inverse">Le petit frère de Grand Shooting</span></a></li>
							{/*<li className="pts"><Link to="/"><span className="u-small color--inverse">Nos studios photo partenaires</span></Link></li>*/}
							<li className="pts"><Link to="/contact"><span className="u-small color--inverse">Nous laisser un petit mot</span></Link></li>
						</ul>
					</div>
					<div className="ptl">
						<p className="u-secondary-bold u-big color--inverse">Besoin d'aide ?</p>
						<ul className="unstyled">
							<li className="pts"><Link to="/help/faq"><span className="u-small color--inverse">Foire aux questions</span></Link></li>
							<li className="pts"><Link to="/help/cgv" className="u-small color--inverse"><span className="color--inverse">Conditions générales de vente</span></Link></li>
							<li className="pts"><Link to="/help/legals"><span className="u-small color--inverse">Mentions légales</span></Link></li>
						</ul>
					</div>
					<div className="ptl">
						<p className="u-secondary-bold u-big color--inverse">Un service proposé par</p>
						<p className="h4-like">
							<Link to="/">
								<svg className="logo-grandshooting-blanc w200p" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 70">
								<path id="G2" className="st0" d="M780.2,52.5c-3.1,1.6-6.5,2.4-10,2.5c-10.9,0-18.3-8.9-16.3-19.9S766.1,15,777.1,15h19.8l2.3-13.2h-19.8c-18.2,0-35.6,15.1-38.8,33.3s9,33,27.2,33c7.7-0.1,15.1-2.5,21.4-6.9c1.8-1.2,3-3.1,3.5-5.2l4.3-24.6l-15.5,13.3L780.2,52.5z"/>
								<path id="N2" className="st0" d="M718.8,40.6l-17.9-36l-0.1-0.1l-0.1-0.1c-1-1.7-2.8-2.6-4.8-2.6c-0.7,0-1.5,0.1-2.2,0.4c-2.8,0.9-4.9,3.3-5.5,6.1l-10.5,59.8h13l6.8-38.4l17.9,35.7l0.1,0.1l0.1,0.1c1,1.7,2.8,2.7,4.8,2.6c0.7,0,1.5-0.1,2.2-0.4c2.8-0.9,4.9-3.3,5.5-6.2l10.6-59.9h-13L718.8,40.6z"/>
								<polygon id="I" className="st0" points="665.4,1.8 653.8,68 667.2,68 678.8,1.8 "/>
								<polygon id="T" className="st0" points="606.2,1.8 603.8,15 622,15 612.6,68.1 626,68.1 635.4,15 653.2,15 655.5,1.8 "/>
								<path id="O2" className="st0" d="M572,1.8c-18.3,0-35.7,14.8-39,33.1S542,68,560.3,68s35.7-14.8,39-33.1S590.2,1.8,572,1.8z M586,34.9c-1.9,11-12.4,19.9-23.4,19.9s-18.3-8.9-16.4-19.9S558.7,15,569.6,15S588,23.9,586,34.9z"/>
								<path id="O" className="st0" d="M500.1,1.8c-18.3,0-35.7,14.8-39,33.1s9,33.1,27.3,33.1s35.7-14.8,39-33.1S518.3,1.8,500.1,1.8z M514.1,34.9c-1.9,11-12.4,19.9-23.4,19.9s-18.3-8.9-16.4-19.9S486.8,15,497.7,15S516,23.9,514.1,34.9L514.1,34.9z"/>
								<polygon id="H" className="st0" points="440.6,31.4 417.1,31.4 422.3,1.8 408.9,1.8 397.2,68.1 410.6,68.1 414.7,44.8 438.3,44.8 434.1,68.1 447.5,68.1 459.2,1.8 445.8,1.8 "/>
								<path id="S" className="st0" d="M349.9,21.6c-2.2,12.6,9.5,16.6,18,19.6c6.8,2.4,11.6,4.2,11.1,7c-0.5,3.1-5.4,6.6-11.5,6.6c-4.4,0.1-8.7-1.5-11.9-4.5l-11,9.4l0.8,0.8c5.3,5,12.4,7.7,19.8,7.6c13,0,25.1-8.9,27.1-19.8c2.2-12.6-9.5-16.7-18-19.6c-6.8-2.4-11.6-4.2-11.1-7c0.5-3.1,5.4-6.6,11.5-6.6h18l2.3-13.3h-18C364,1.8,351.8,10.7,349.9,21.6z"/>
								<path id="D" className="st0" d="M303.6,1.9h-22.9c-1,0-1.9,0.7-2.1,1.8l-11,62.3c-0.2,1,0.4,2,1.4,2.2c0.1,0,0.3,0,0.4,0h22.9c17.9,0,35-14.8,38.2-32.9c1.6-9-0.5-17.5-5.8-23.9C319.7,5.3,312.2,1.9,303.6,1.9z M326.7,34.8c-2.9,16.2-18.1,29.4-34.1,29.4H272l10.3-58.3h21.1c7-0.2,13.8,2.8,18.4,8.1C326.3,19.5,328.1,26.9,326.7,34.8z"/>
								<path id="N" className="st0" d="M244.1,60.3L211.6,2.8c-0.4-0.8-1.4-1.1-2.2-0.8c-0.7,0.3-1.3,0.9-1.4,1.7l-11.4,64.5h4l10.3-58.4l32.5,57.5c0.4,0.8,1.4,1.1,2.2,0.8c0.8-0.2,1.3-0.9,1.5-1.7l11.4-64.4h-4L244.1,60.3z"/>
								<path id="A" className="st0" d="M164.2,2.9l-42.1,65.3h4.6l14.5-22.5h34.7l6.6,22.5h4.2l-18.9-65c-0.4-1-1.6-1.5-2.6-1.1C164.7,2.3,164.4,2.5,164.2,2.9z M143.7,41.8l21.4-33.2l9.7,33.2H143.7z"/>
								<path id="R" className="st0" d="M123.8,24c1.1-5.5-0.3-11.3-3.8-15.7c-3.6-4.2-8.9-6.5-14.4-6.4h-24c-1,0-1.9,0.7-2.1,1.8L68.2,68.1h4l4-22.4h22.4L111,68.2h4.6l-12.7-23C113.2,43.2,122,34.3,123.8,24z M98.6,41.8H76.8l6.3-35.9h22.2c4.4-0.1,8.7,1.7,11.5,5.1c2.8,3.6,3.9,8.2,3,12.7C118.2,33.6,108.6,41.8,98.6,41.8z"/>
								<path id="G" className="st0" d="M39.9,1.9C21.8,1.9,4.4,16.7,1.3,34.8c-1.6,9,0.5,17.4,5.8,23.7s12.9,9.6,21.6,9.6c7.7-0.1,15.1-2.5,21.4-6.9c0.5-0.3,0.8-0.8,0.9-1.4l3.5-20l-4.7,4l-2.6,14.7c-5.4,3.6-11.8,5.6-18.3,5.7c-7.6,0-14.3-3-18.8-8.3S3.8,43,5.2,35.2C8,19,23.5,5.8,39.7,5.8c6-0.1,11.9,1.9,16.4,5.8l1.7,1.5l0.8-4.7L58,8C52.9,3.9,46.5,1.8,39.9,1.9z"/></svg>
							</Link>
						</p>
						<p className="u-small u-italic pts">Copyright © 2018 Grafmaker SAS.<br/>Imaginé et réalisé à Paris, France.</p>
					</div>
				</nav>
			</footer>
		)
	}
}
const FooterWithRouter = withRouter(Footer)


class ShoppingCart extends Component {
	state = {
		message: typeof document ? document.message : '',
		address: this.getSavedPlace(),
		selectedDay: this.getSelectedDay()
	}
	componentDidMount = () => {
		document.addEventListener('shoppingcart', () => this.forceUpdate())
	}
	changeMessage = event => {
		this.setState({ message: event.target.value })
		document.message = event.target.value
	}

	handleShoppingCartTooltip = (event) => {
		this.props.handleShoppingCartTooltip(event)
	}
	onChangeAddress = address => this.setState({ address })

	onBlurAddress = () => {
		if (_.trim(this.state.address) === '') {
			document.currentAddress = null
			localStorage.currentAddress = null
			return
		}
		geocodeByAddress(this.state.address).then(res => {
			console.log("geocodeByAddress", res)
			document.currentAddress = res[0]
			localStorage.currentAddress = JSON.stringify(res[0])
		})
	}

	onSelectAddress = address => {
		console.log(address)
		if (_.trim(address) === '') {
			document.currentAddress = null
			localStorage.currentAddress = null
			return
		}
		geocodeByAddress(address).then(res => {
			console.log("geocodeByAddress", res)
			document.currentAddress = res[0]
			localStorage.currentAddress = JSON.stringify(res[0])
			this.setState({ address: res[0].formatted_address })
		})
	}

	getSavedPlace() {
		if (typeof localStorage !== 'undefined' && localStorage.currentAddress) {
			try {
				const addr = JSON.parse(localStorage.currentAddress)
				document.currentAddress = addr

				return addr.formatted_address
			} catch(e) {
				return undefined
			}
		}
	}

	getSelectedDay() {
		if (localStorage.selectedDay) {
			try {
				let selectedDay = moment(localStorage.selectedDay)

				if (selectedDay.isBefore(moment())) {
					return undefined

				}
				document.selectedDay = selectedDay

				return selectedDay.toDate()
			} catch(e) {
				return undefined
			}
		}
	}

	onDayChange = date => {
		document.selectedDay = date
		localStorage.selectedDay = moment(date).format()
		this.setState({selectedDay: date})
		setTimeout(() => {document.getElementById("delivery-place").focus()}, 0)
	}

	getMinDate() {
		if (moment().day() === 5) { // friday, show monday
			return moment().weekday(8).toDate()
		} else if (moment().day() === 6) { // saturday, show monday
			return moment().weekday(8).toDate()
		}
		else {
			return moment().add('days', 1).toDate()
		}
	}

	getForbidenDay() {
		return [
			new Date("01/01/2018"),
			new Date("02/04/2018"),
			new Date("01/05/2018"),
			new Date("08/05/2018"),
			new Date("10/05/2018"),
			new Date("21/05/2018"),
			new Date("14/07/2018"),
			new Date("15/08/2018"),
			new Date("01/11/2018"),
			new Date("11/11/2018"),
			new Date("25/12/2018")
		]
	}

	checkDeliveryInfo = (event) => {
		const deliveryInfo = document.getElementById('delivery-info')
		const deliveryDate = document.getElementById('delivery-date')
		const deliveryPlace = document.getElementById('delivery-place')
		const dateError = document.getElementById('delivery-date-error')
		const placeError = document.getElementById('delivery-place-error')
		const zoneError = document.getElementById('delivery-zone-error')
		
		var showError = function(target) { target.classList.remove('js-hidden') }
	
		dateError.classList.add('js-hidden')
		placeError.classList.add('js-hidden')
		zoneError.classList.add('js-hidden')
		deliveryDate.classList.remove('input--error');
		deliveryPlace.classList.remove('input--error');

		if (!document.selectedDay || !document.currentAddress || !utils.checkAddress(document.currentAddress))
			deliveryInfo.scrollIntoView(true);

		if (!document.selectedDay) { // Pas de date
			deliveryDate.focus();
			deliveryDate.classList.add('input--error');
			showError(dateError);
			if(!document.currentAddress || !utils.checkAddress(document.currentAddress))
				deliveryPlace.classList.add('input--error');
			if (!document.currentAddress) // Pas de date + pas d'adresse
				showError(placeError);
			else if (!utils.checkAddress(document.currentAddress)) // Pas de date + Adresse non valide
				showError(zoneError);
		} else if (!document.currentAddress || !utils.checkAddress(document.currentAddress)) { // Date ok + Pas d'adresse ou adresse non valide
			deliveryPlace.focus();
			deliveryPlace.classList.add('input--error');
			if (!document.currentAddress) // Date ok + Pas d'adresse
				showError(placeError);
			else if (!utils.checkAddress(document.currentAddress)) // Date ok + Adresse non valide
				showError(zoneError);
		} else { // Date ok + Adresse ok => On redirige sur Purchase
			this.props.handleShoppingCartTooltip(event)
			this.props.history.push("/purchase")
		}
	}

	render() {
		
		let popup = <div className="tiny-mlm tiny-mrm extra-large-mr0 mll mrl mts ptm pbm bgc--inverse bdra--m box-shadow">
						<p className="plm mls prm mrs mts u-small">Votre panier est vide. <br />
							Le service clients est à votre disposition au <span className="u-txt-ellipsis">01 76 35 08 66</span> du lundi au vendredi de <span className="u-txt-ellipsis">10h à 18h</span>.
						</p>
					</div>

		if (getShoopingCartNumber()) {
			console.log("getShoopingCart() = " + getShoopingCart())
			const shoppingCart = getShoopingCart()
			console.log("shoppingCart", shoppingCart)
			const fee_ht = 15
			// const fee_ttc = fee_ht * 1.2
			const total_ht = fee_ht + _.sum(_.map(_.groupBy(shoppingCart), (value, offer_id) => {
				const offer = _.find(this.props.offers, o => o.offer_id == offer_id) || {}
				const price_ht = (_.find(offer.price, p => p.from <= _.size(value) && ((p.to && _.size(value) <= p.to) || !p.to)) || {price_ht: 0}).price_ht
				// const price_ttc = price_ht * 1.2

				return price_ht * _.size(value)
			}))
			const total_ttc = total_ht * 1.2
			const deliveryDate = utils.addBusinessDays(document.selectedDay, 3).format('dddd LL')
			
			popup = <div className={"mts pls prs ptm pbm bgc--inverse bdra--m box-shadow" + (this.props.isMobileDevice ? " d-flex pos-f" : " tiny-mlm tiny-mrm mrl extra-large-mr0")}>
						<div className="w100 h100 custom-scrollbar custom-all-scrollbar all-auto-scrollbar">
							<p className="h4-like plm prm pts pb0 u-secondary-bold"><span className="prt">{getShoopingCartNumber()}&nbsp;</span>{getShoopingCartNumber() > 1 ? "produits" : "produit"} dans votre panier</p>
							<hr className="mam tiny-mts"/>
							<div className={"shopping-cart-tooltip-items d-flex pts plm prm tiny-ma0 custom-scrollbar custom-all-scrollbar all-auto-scrollbar" + (this.props.isMobileDevice ? " mlm mrs" : "")}>
								<div className="flex-item-fluid">
								{
									_.map(_.groupBy(shoppingCart), (v, offer_id) => {
										const quantity = _.size(v)
										const offer = _.find(this.props.offers, o => o.offer_id == offer_id) || {}
										const price_ht = (_.find(offer.price, p => p.from <= quantity && ((p.to && quantity <= p.to) || !p.to)) || {price_ht: 0}).price_ht
										
										const total = price_ht * quantity
										const last = offer_id === _.last(_.sortBy(shoppingCart))

										return (
											<div className={last ? "d-flex flex-nowrap" : "d-flex flex-nowrap pbm"} key={offer_id}>
												<div className="w70p h70p mrm bdra--s of-hidden">
													<img className="d-inbl w100 h70p bgc--tertiary bdra--s" src={utils.getImgPath(_.first(offer.images))} alt="" style={{objectFit: 'contain'}}/>
												</div>
												<div className="flex-item-fluid u-small mauto">
													<p className="d-flex flex-align-baseline">
														<span className="tiny-w100 prs">{offer.smalltext || 'Offre indisponible'}</span>
														<span className="u-small u-italic">{'(' + (offer.nb_image > 1 ? (offer.nb_image === 3 ? (offer.nb_image - 1) + ' vues' : offer.nb_image + ' vues') : offer.nb_image + ' vue') + (offer.smalltext === "Ghost" ? " + détail offert" : "") + ')'}</span>
														<span className="color--disabled flex-item-fluid txtright">{utils.printPrice(price_ht)}€</span>
													</p>
													<p className="d-flex tiny-mbt">
														<span>
															<button className="pos-r w30p h30p circle btn--secondary" onClick={() => { addShoppingCart(offer_id); this.props.handleShoppingCartCounterAnimation()}}><span className="pos-a posa-left posa-bottom posa-right pbt u-biggest u-secondary-bold color--inverse">+</span></button>
															<button className="pos-r w30p h30p circle btn--secondary mls" onClick={() => { removeShoppingCart(offer_id); this.props.handleShoppingCartCounterAnimation()}}><span className="pos-a posa-left posa-bottom posa-right pbt u-biggest u-secondary-bold color--inverse">-</span></button>
														</span>
														<span className="flex-item-fluid mauto txtright">
															<span>{'x' + quantity}</span>
															<span className="tiny-pls plm">{utils.printPrice(total) + '€'}</span>
														</span>
													</p>
												</div>
											</div>
										)
									})
								}
								</div>
							</div>
							<div className="ptt plm prm d-flex u-small">
								<span>
									<span className="d-inbl lnr lnr-rocket u-bigger mtauto mbauto mrs"></span>
									<span>Coursier :</span> 
								</span>
								<span className="flex-item-fluid txtright">15€</span>
							</div>
							{/*<hr className={"mam"}/>
							<div className={"plm mls prm mrs u-small"}>
								<div>
									<span className="d-inbl lnr lnr-pencil u-bigger mtauto mbauto mrs"></span>
									<span>Un petit mot pour le photographe:</span> 
								</div>
								<div>
									<textarea className='w100 mtm' rows='4' value={typeof document ? document.message : ''} onChange={this.changeMessage} />
								</div>
							</div>*/}
							<hr className="tiny-mas mam"/>
							<div className="plm prm">
								<div className="d-flex flex-space-between u-bold pbs">
									<span>Total HT</span>
									<span>{utils.printPrice(total_ht) + '€'}</span>
								</div>
								<div className="d-flex flex-space-between u-small color--disabled">
									<span>Total TTC</span>
									<span>{utils.printPrice(total_ttc) + '€'}</span>
								</div>
							</div>
							{/*<hr className="mam tiny-mbs"/>*/}
							<div id='delivery-info' className="pos-r mtm mbm">
								<hr className="ma0 mrs"/>
								<div className="pos-r pam zi2">
									<p className="u-bold pts">Quand peut-on venir chercher vos&nbsp;produits&nbsp;?<span className="pls color--primary-darken">&nbsp;*</span></p>
									<p id="delivery-date-error" className="color--primary-darken u-small italic js-hidden"><span className="u-small">Merci d'indiquer une date de retrait des produits.</span></p>
									<label className="d-flex flex-space-between mrs">
										<DayPickerInput
											inputProps={{id:'delivery-date', readOnly: true}}
											formatDate={formatDate}
											parseDate={parseDate}
											format="LL"
											value={this.state.selectedDay}
											onDayChange={this.onDayChange}
											component={React.Component = "input"}
											placeholder={'Choisir une date'}
											dayPickerProps={{
												locale: 'FR',
												localeUtils: MomentLocaleUtils,
												disabledDays: [
													{daysOfWeek: [0, 6]},
													{before: this.getMinDate()}
												].concat(this.getForbidenDay())
											}}
										/>
										<span className="d-inbl lnr lnr-calendar-full u-bigger mtauto mbauto mls w10 txtright"></span>
									</label>
									<p className="u-bold tiny-pts ptm">À quelle adresse&nbsp;?<span className="pls color--primary-darken">&nbsp;*</span></p>
									<p id="delivery-place-error" className="color--primary-darken u-small italic js-hidden"><span className="u-small">Merci d'indiquer une adresse de retrait des produits.</span></p>
									<p id="delivery-zone-error" className='color--primary-darken u-small italic js-hidden'><span className="u-small">Désolé, notre service n'est pas encore disponible sur cette zone.</span></p>
									<label className="d-flex flex-item-fluid flex-space-between mrs">
										<PlacesAutocomplete
											inputProps={{id:'delivery-place', value:this.state.address, placeholder: "Saisir une adresse", onBlur:this.onBlurAddress, onChange: this.onChangeAddress}}
											onSelect={this.onSelectAddress}
											onEnterKeyDown={this.onSelectAddress}
											/>
										<span className="d-inbl lnr lnr-map-marker u-bigger mtauto mbauto mls w10 txtright"></span>
									</label>
									<p className="color--primary-darken u-small italic tiny-ptt pts mbt"><span className="u-small">* Informations obligatoires</span></p>
								</div>
								<hr className="ma0 mrs"/>
								<div className="pos-a posa-top posa-bottom posa-left posa-right mrs bgc--pastel4 zi1 o70"></div>
							</div>
							{/*<hr className="mam mts tiny-mbs"/>*/}
							<div className="tiny-pts ptt plm prm">
								<p className="tiny-w100 d-flex flex-align-baseline">
									<span className="tiny-w100 u-bold">Vous serez livré le :</span>
									<span className=" flex-item-fluid txtright tiny-txtleft u-small">{deliveryDate}</span>
								</p> 
							</div>
							<hr className="mam"/>
							<div className="pts pbs plm prm">
								<button className="btn--block btn--big btn--secondary" onClick={this.checkDeliveryInfo}><span className="color--inverse">Poursuivre ma commande</span></button>
							</div>
						</div>
					</div>
		}

		return (
			<div>
			{ 
				getShoopingCartNumber() >= 1 ?
					<div id="shopping-cart-btn" className="pos-r d-flex zi10 c-pointer" onMouseEnter={this.handleShoppingCartTooltip} onMouseLeave={this.handleShoppingCartTooltip} onClick={this.handleShoppingCartTooltip}>
						<span className="lnr lnr-cart u-bigger mtt mrs"></span>
						<span className="u-small mauto prs tiny-hidden">Panier</span>
						<span id="shopping-cart-counter" className="d-flex circle w50p h50p tiny-w30p tiny-h30p u-secondary-bold bgc--secondary color--inverse">
							<span className="d-inbl mauto u-big">{getShoopingCartNumber()}</span>
						</span>
					</div>
				:
					<div id="shopping-cart-btn" className="pos-r d-flex zi10" onClick={this.handleShoppingCartTooltip} disabled>
						<span className="lnr lnr-cart u-bigger mtt mrs"></span>
						<span className="u-small mauto prs tiny-hidden">Panier</span>
						<span id="shopping-cart-counter" className="d-flex circle w50p h50p tiny-w30p tiny-h30p u-secondary-bold bgc--secondary color--inverse">
							<span className="d-inbl mauto u-big">{getShoopingCartNumber()}</span>
						</span>
					</div>
			}
				<div className={"shopping-cart-tooltip pos-a posa-top posa-right ptxl zi0" + (this.props.isVisible ? " fade-in-down-animation" : " is-hidden")}>
					<div className="pos-a posa-right mrl extra-large-ma0">
						<div className="icon-carret--up mrm"></div>
					</div>
					{ popup }
				</div>
			</div>
		)
	}
}
const ShoppingCartWithRouter = withRouter(ShoppingCart)

// class ConstructPage extends Component {
// 	componentWillMount() {
// 		isLoginCheck().catch(err => {
// 			this.props.history.replace("/login?goto=myaccount")
// 		})
// 	}
// 	render() {
// 		return (
// 			<main id="main" className="pos-f w100 h100 flex-container zi4" role="main">
// 				<section className="w40 tiny-h40 tiny-w100 color--inverse bgc--primary pbxl pll prl tiny-pl0 tiny-pr0 of-hidden">
// 					<div className="h1-like right tiny-w60 small-w100 medium-w80 large-w70 extra-large-w60 tiny-ptm ptl tiny-prl medium-prl large-prl extra-large-prl">
// 						<LogoLittleShooting className="logo-littleshooting"/>
// 						<span className="visually-hidden">Little Shooting</span>
// 					</div>
// 					<div className="pos-a mauto w100 tiny-pts ptm">
// 						<img className="w50 tiny-w100 small-w60 tiny-pt0 tiny-plxl large-pll extra-large-plxl ptl" src="/assets/images/home-01.png" alt=""/>
// 					</div>
// 				</section>
// 				<section className="w60 tiny-h60 tiny-w100 bgc--inverse plxl prxl ptm pbxl zi1">
// 					<div className="pll prl">
// 						<div className="ptl pbm"><Link className="btn--ghost" to="/">&#60;&nbsp;Retour à la liste des offres</Link></div>
// 						<div className="ptl">
// 							<h1 className="h3-like">En construction</h1>
// 							<p className="pts ma0">Cette page sera très prochainement disponible.</p>
// 						</div>
// 					</div>
// 				</section>
// 			</main>
// 		)
// 	}
// }

export default App;




// WEBPACK FOOTER //
// ./src/App.js